export const BACKSIDE_FORMAT = {
  A6: "a6",
  A5: "a5",
  A51: "a51",
  A4: "a4",
} as const;

export const BACKSIDE_TEMPLATE = {
  CONFIRM_TITLE: "Confirm template",
  CONFIRM_MESSAGE:
    "Are you satisfied with this template? Changes will be deployed via the pipeline.",
  CONFIRM_SUCCESS: "Template reviewed. Commit your changes to deploy.",
} as const;

export const BACKSIDE_IMAGE_PATH: Record<string, string> = {
  a4: "",
  a5: "",
  a51: "",
  a6: "",
} as const;

export default {
  DASHBOARD_APPS: {
    RIKTIGA_VYKORT: "riktigaVykort",
    CREATE_MAIL_OUT: "createMailOut",
  },
  ACTION_STATUS: {
    SUCCESS: "success",
    FAILURE: "error",
  },
  PLATFORMS: {
    IOS: "ios",
    ANDROID: "android",
    WEB: "web",
  },
  NOTIFICATION: {
    SUCCESS: "success",
    ERROR: "error",
  },
  ACTIONS: {
    ADD: "ADD",
    EDIT: "EDIT",
    DELETE: "DELETE",
  },
  MAILOUT_STATUSES: {
    STARTED: "STARTED",
    PROCESSED: "PROCESSED",
    UNPROCESSED: "UNPROCESSED",
    PLACED: "PLACED",
    DELIVERED: "DELIVERED",
    CANCELLED: "CANCELLED",
  },
  CREATE_MAILOUT: {
    PAGE_LIMIT: 10,
    PAGE_NUMBER: 1,
    PRODUCT_ID: "6000",
    STATUS_DETAILS: {
      PENDING:
        "Initial order status when the place order flow is initiated before the order is registered in NOPS.",
      PLACED: "Order created, payment initiated, awaiting user payment.",
      CANCELLED:
        "The order has been cancelled and should no longer progress through production.",
      UNPROCESSED:
        "The order exists, but it has not yet been sent to Strålfors.",
      PROCESSED:
        "The order package has been successfully uploaded to Strålfors.",
      STARTED: "Strålfors has confirmed that printing has started.",
      DELIVERED: "Strålfors has handed it over to PostNord for distribution.",
    },
  },
  TAG_THEME_IDS: {
    THEME: 1,
    VISUAL_QUALITY: 2,
    LANGUAGE: 3,
  },
  TAG_CATEGORY_NAME_PREFIXES: {
    DOMINANT_COLOR: "Dominant",
    LANGUAGE: "Language",
  },
  STICKER_VALIDATION: {
    SELECT_AT_LEAST_ONE_OPTION: "Please select at least one option",
  },
  PRICE_MANAGEMENT: {
    PRODUCT_CODE: "6000",
    W2P_BASE_ADR_STARTAVGIFT: "Starting fee",
    W2P_ADR_DISTRIBUTION: "Distribution",
    W2P_PRINT_PRICE_POSTCARDS: "Print",
    W2P_REFERENCE_SAMPLES: "Reference samples",
    W2P_ADDRESS_PURCHASE: "Address purchase",
    UPDATE_SUCCESS_MESSAGE: "Price list updated successfully.",
    UPDATE_ERROR_MESSAGE: "Unable to update price list. Please try again.",
    CLONE_SUCCESS_MESSAGE: "Price list cloned successfully.",
    CLONE_ERROR_MESSAGE: "Unable to clone price list. Please try again.",
    CLONE_ID_REQUIRED_ERROR_MESSAGE: "Please select a price list to clone.",
    CLONE_NOT_FOUND_ERROR_MESSAGE:
      "The price list to clone could not be found.",
    CLONE_DUPLICATE_MAPPING_ERROR_MESSAGE:
      "A duplicate product mapping already exists for this price list.",
    DELETE_SUCCESS_MESSAGE: "Price list deleted successfully.",
    DELETE_ERROR_MESSAGE: "Unable to delete price list. Please try again.",
    DELETE_NOT_FOUND_ERROR_MESSAGE:
      "This price list could not be found. It may have already been deleted.",
    DELETE_STATUS_NOT_ALLOWED_ERROR_MESSAGE:
      "Only price lists in draft status can be deleted.",
    DELETE_RELATED_RECORDS_ERROR_MESSAGE:
      "This price list cannot be deleted because related records still exist.",
    VAT_UPDATE_SUCCESS_MESSAGE: "VAT price updated successfully.",
    VAT_UPDATE_ERROR_MESSAGE: "Unable to update VAT price. Please try again.",
    SAP_UPDATE_SUCCESS_MESSAGE: "SAP price updated successfully.",
    SAP_UPDATE_ERROR_MESSAGE: "Unable to update SAP price. Please try again.",
    SAP_PRICE_TYPE: {
      FIXED: "fixed",
      UNIT: "unit",
    },
    SAP_PRICE_REQUIRED_ERROR_MESSAGE: "Price is required.",
    SAP_PRICE_INVALID_ERROR_MESSAGE: "Enter a price greater than 0.",
    SAP_MIN_QTY_REQUIRED_ERROR_MESSAGE: "Min Qty is required for unit prices.",
    SAP_MIN_QTY_INVALID_ERROR_MESSAGE: "Min Qty must be a number.",
    SAP_MAX_QTY_REQUIRED_ERROR_MESSAGE: "Max Qty is required for unit prices.",
    SAP_MAX_QTY_INVALID_ERROR_MESSAGE: "Max Qty must be a number.",
    SAP_REQUIRED_FIELDS_ERROR_MESSAGE: "Type and Effective From are required.",
  },
};
